<div class="password-reinit-container">
    <h2>MonPharmacien</h2>
    <ng-container *ngIf="!afterSuccess; else success">
        <div *ngIf="!isError(); else error" class="password-reinit-form">
            <h3>Réinitialisation du mot de passe</h3>
            <form *ngIf="passwordForm" [formGroup]="passwordForm" (ngSubmit)="onSubmit()">
                <div class="section section-edit">

                    <div *ngIf="submitted && field.newPassword.errors" class="invalid-feedback">
                        <div *ngIf="field.newPassword.errors.required">Le mot de passe est requis</div>
                        <div *ngIf="field.newPassword.errors.minlength">Le mot de passe doit être composé d'au minimum 8 caractères</div>
                        <div *ngIf="field.newPassword.errors.pattern">Le mot de passe doit contenir au moins :
                            <ul>
                                <li> Une majuscule </li>
                                <li> Une minuscule </li>
                                <li> Un caractère spécial </li>
                                <li> Un chiffre</li>
                            </ul>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="section-edit-form-label col-md-7">
                            <label>Nouveau mot de passe : </label>
                        </div>
                        <div class="section-edit-form-input col-md-5">
                            <input type="password" formControlName="newPassword"
                                [ngClass]="{'is-invalid': submitted && field.newPassword.errors }" />
                        </div>
                    </div>

                    <div *ngIf="submitted && field.confirmPassword.errors" class="invalid-feedback">
                        <div *ngIf="field.confirmPassword.errors.required">Le mot de passe nécessite une confirmation</div>
                        <div *ngIf="field.confirmPassword.errors.mustMatch">Les deux champs ne sont pas identiques</div>
                    </div>
                    <div class="form-group row">
                        <div class="section-edit-form-label col-md-7">
                            <label>Confirmation du mot de passe : </label>
                        </div>
                        <div class="section-edit-form-input col-md-5">
                            <input type="password" formControlName="confirmPassword"
                                [ngClass]="{'is-invalid': submitted && field.confirmPassword.errors }" />
                        </div>
                    </div>

                    <div class="form-group section-edit-form-button">
                        <button type="submit" class="btn btn-giphar">Valider</button>
                    </div>

                </div>
            </form>
        </div>
        <ng-template #error>
            <p>{{errorMessage}}</p>
        </ng-template>
    </ng-container>

    <ng-template #success>
        <div class="success-container">
            <p class="check-icon"><i class="far fa-check-circle"></i></p>
            <p>Votre mot de passe a été modifié avec succès !</p>
            <p>A bientôt sur l'application MonPharmacien</p>
        </div>
    </ng-template>

</div>
